const CONTROL_FLOW_DIGEST_PREFIXES = [
  "NEXT_REDIRECT",
  "NEXT_NOT_FOUND",
  "NEXT_HTTP_ERROR_FALLBACK",
];

export function isNextControlFlowDigest(value: unknown): boolean {
  if (typeof value !== "string") return false;
  return CONTROL_FLOW_DIGEST_PREFIXES.some(
    (prefix) => value === prefix || value.startsWith(`${prefix};`),
  );
}

export function isNextControlFlowError(error: unknown): boolean {
  if (typeof error === "object" && error !== null && "digest" in error) {
    if (isNextControlFlowDigest(Reflect.get(error, "digest"))) return true;
  }
  if (error instanceof Error) return isNextControlFlowDigest(error.message);
  return isNextControlFlowDigest(error);
}

export function describeNextControlFlowDigest(digest: string): string {
  const [kind, mode, ...rest] = digest.split(";");
  if (kind !== "NEXT_REDIRECT") return [kind, mode].filter(Boolean).join(";");
  const parts = rest.filter(Boolean);
  const status = parts[parts.length - 1];
  return [kind, mode, status].filter(Boolean).join(";");
}
